import React, { useState } from "react";
import {
  Card,
  CardImg,
  CardTitle,
  CardSubtitle,
  CardHeader,
  CardBody,
} from "reactstrap";
import StudentStatus from "./StudentStatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const StudentCourse = (props) => {
  const [imgError, setImgError] = useState(false);
  const navigate = useNavigate();
  return (
    <Card
      className={
        props.active === "true" ? "hover link bg-primary" : "hover link"
      }
      id={props.course.id}
      onClick={() => navigate(`/student/coursemodules/${props.course.id}/`)}
      style={{
        borderRadius: "10px",
        boxShadow: "0 2px 2px rgba(0, 0, 0, 0.06)",
        cursor: "pointer",
        border: "none",
        height: "100%",
      }}
    >
      <CardHeader style={{ padding: "0" }}>
        {!imgError && props.course.imgUrl ? (
          <CardImg
            src={`${process.env.PUBLIC_URL}/${props.course.imgUrl}`}
            alt="course cover"
            onError={() => setImgError(true)}
          />
        ) : (
          <div
            style={{
              aspectRatio: "16/9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "15px",
            }}
          >
            <FontAwesomeIcon icon="book" size="3x" color="#ccc" />
          </div>
        )}
        <div className="student-progress">
          <StudentStatus className="pull-right" status={props.course.status} />
        </div>
      </CardHeader>
      <CardBody style={{ padding: "0.85rem" }}>
        <CardTitle>{props.course.name}</CardTitle>
        <CardSubtitle>{props.course.description}</CardSubtitle>
      </CardBody>
    </Card>
  );
};

export default StudentCourse;
